import { render, staticRenderFns } from "./OrganisationsContent.vue?vue&type=template&id=5a088570&scoped=true"
import script from "./OrganisationsContent.vue?vue&type=script&lang=js"
export * from "./OrganisationsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a088570",
  null
  
)

export default component.exports